import React from 'react';
import styled from 'styled-components';
import ALRAAssertionsTable from './ALRAAssertionsTable';
import {labels} from '../../../../../../../util/utils';
import SelectDropdown from '../../../../../../Common/SelectDropdown/SelectDropdown';

export default function ALRAAssertions({selectedStEntityId}) {
	return (
		<StyledALRAAssertions className="StyledALRAAssertions">			
			<ALRAAssertionsTable selectedStEntityId={selectedStEntityId}/>
		</StyledALRAAssertions>
	);
}

const StyledALRAAssertions = styled.section`
	display: flex;
	flex-direction: column;
	.select-dropdown {
		&.ALRA_Dropdown_Select {
			width: var(--px-400);
			margin-bottom: var(--px-20);
		}
	}
`;
